import { render, staticRenderFns } from "./new_customer_form.vue?vue&type=template&id=8b3f3d36&lang=pug"
import script from "./new_customer_form.vue?vue&type=script&lang=js"
export * from "./new_customer_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports